import { getTheme, IconButton, IIconProps, IStackItemStyles, Link, Stack, StackItem } from '@fluentui/react';
import React from 'react';
import { AuthProvider } from '../../services';
import { QueueConfiguration } from '../../services/queue.model';
import { formatGenericEmailHref } from '../util';
import { TenantTitleSectionWithRouter } from './components';

const menuIcon: IIconProps = { iconName: 'GlobalNavButton' };
const collapseWidth: React.CSSProperties = {
  width: '50px',
  minWidth: '50px'
};
const expandWidth: React.CSSProperties = {
  width: '250px',
  minWidth: '250px'
};
const strictStackItemFlex: IStackItemStyles = {
  root: {
    flexBasis: '0',
    overflowY: 'auto',
    overflowX: 'hidden'
  }
};

interface NavigationSidebarState {
  isCollapsed: boolean;
}

interface NavigationSidebarProps {
  configs: QueueConfiguration[];
}

export class NavigationSidebar extends React.PureComponent<NavigationSidebarProps, NavigationSidebarState> {
  private userId: string;

  constructor(props) {
    super(props);
    this.userId = AuthProvider.getAccount().userName;
    this.state = {
      isCollapsed: true
    };
  }

  render(): JSX.Element {
    const { palette } = getTheme();
    const minWidth: React.CSSProperties = this.state.isCollapsed ? collapseWidth : expandWidth;
    const sidebarStyle: React.CSSProperties = {
      backgroundColor: palette.neutralLight,
      transition: 'min-width 150ms ease-in-out, width 150ms ease-in-out',
      ...minWidth,
      overflow: 'hidden'
    };
    const collapseButtonStyle = {
      root: {
        backgroundColor: palette.neutralLight
      }
    };
    const userId = this.userId;

    return (
      <Stack className="h-100 overflow-hidden" style={sidebarStyle}>
        <Stack.Item styles={collapseButtonStyle}>
          <IconButton
            style={collapseWidth}
            className="p-4"
            iconProps={menuIcon}
            onClick={(): void => this.toggleCollapse()}
          />
        </Stack.Item>
        <Stack.Item grow shrink styles={strictStackItemFlex}>
          {!this.state.isCollapsed && (
            <TenantTitleSectionWithRouter configs={this.props.configs} palette={palette} userId={userId} />
          )}
        </Stack.Item>
        {!this.state.isCollapsed && (
          <StackItem className="text-center">
            <div style={expandWidth}>
              <span>Microsoft Confidential</span>
              <br />
              <Link className="pr-2" href={formatGenericEmailHref()}>
                Feedback
              </Link>
              <br />
              <Link
                className="pr-2"
                href="http://go.microsoft.com/fwlink/?LinkId=518021"
                rel="noopener noreferrer"
                target="_blank"
              >
                Employee Data Protection Notice
              </Link>
            </div>
          </StackItem>
        )}
      </Stack>
    );
  }

  private toggleCollapse(): void {
    const isCollapsed = !this.state.isCollapsed;
    this.setState({
      isCollapsed
    });
  }
}

export default NavigationSidebar;
